module.exports = __webpack_public_path__ + "static/media/mymfbcover_en_US.1b4ffa2d.png";